import { jsx as e } from "react/jsx-runtime";
const a = (i) => /* @__PURE__ */ e("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", "aria-hidden": !0, focusable: !1, ...i, children: /* @__PURE__ */ e("path", { fill: "currentColor", d: "M10 12a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm0-9a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm0 18a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z" }) });
export {
  a as default
};
//# sourceMappingURL=ellipsis-vertical.js.map
